import React from "react";

const ElementTableContext = React.createContext();

export default ElementTableContext;
